import classnames from 'classnames';

import { CmsBoxList } from '@interfaces/common';

import styles from './BoxList.module.css';
import { BoxListItem } from './BoxListItem';

export const BoxList: React.VFC<CmsBoxList> = ({
	isHidden = false,
	title,
	boxListItems,
}) => {
	return !isHidden ? (
		<section className={classnames(styles.wrapper, 'stack-block')}>
			<div className={styles['title-wrapper']}>
				<h2 className="fluid-font-t2">{title}</h2>
			</div>
			<ul className={classnames(styles.grid, 'grid')}>
				{boxListItems.map(({ _key, ...rest }) => (
					<li key={_key}>
						<BoxListItem {...rest} />
					</li>
				))}
			</ul>
		</section>
	) : null;
};
